module.exports = __webpack_public_path__ + "static/media/anarc_logo.990370c5.png";